export function isDeepActive(menu) {
  if (!menu) return false;
  // Search recursively through potential children
  const searchActive = (accum, item) => {
    let active = ('active' in item) && item.active ? true : accum;
    if (!active && ('subMenu' in item)) {
      active = item.subMenu.reduce(searchActive, false);
    }
    if (!active && ('jumpMenu' in item)) {
      active = item.jumpMenu.reduce(searchActive, false);
    }
    return active;
  };
  return menu.reduce(searchActive, false);
}

export function getMenuItemType(menuItem) {
  if (('link' in menuItem) || ('anchor' in menuItem)) return 'lds-link';
  return 'lds-button-base';
}

// Add IDs to all menu items for later referencing
export function addIdsToMenu(menu) {
  const process = (item, i, parentId = '') => {
    const processedItem = {
      ...item,
      id: `${parentId !== '' ? `${parentId}_` : ''}${i}`,
    };
    if ('subMenu' in item) {
      processedItem.subMenu = processedItem.subMenu.map(
        (subMenuItem, subMenuI) => process(subMenuItem, subMenuI, processedItem.id)
      );
    }
    return processedItem;
  };
  return menu.map((item, topI) => process(item, topI));
}

// Checks a menu item href to see if menu item is current active route
export function isItemActiveFromRoute(item, currentRoute) {
  if (!('link' in item)) return false;
  // Strip slashes from beginning and end for matching, also strip any url parameters
  const link = item.link.to || item.link.href;
  if (!link.includes('?')) return link === currentRoute;

  const strippedUrl = link.slice(0, link.indexOf('?'));
  return strippedUrl === currentRoute;
}

export function setActiveMenuRoutes(menu, currentRoute) {
  // if (!this.routing) return menu;
  const process = (item) => {
    const processedItem = { ...item };
    const isActive = isItemActiveFromRoute(item, currentRoute);
    processedItem.active = isActive;
    processedItem.current = isActive;
    if ('subMenu' in item) {
      processedItem.subMenu = processedItem.subMenu.map(process);
    }
    return processedItem;
  };
  return menu.map(process);
}

// Determines if this menu has an current menu item as a child somewhere.
export function deepCurrent(menu) {
  if (!menu) return false;
  // Search recursively through potential children
  const searchCurrent = (accum, item) => {
    let current = ('current' in item) && item.current ? true : accum;
    if (!current && ('subMenu' in item)) {
      current = item.subMenu.reduce(searchCurrent, false);
    }
    return current;
  };
  return menu.reduce(searchCurrent, false);
}

// Determines if the menu item is the current page or has a descendant that is.
export function menuItemHasCurrent(menuItem) {
  if (('current' in menuItem) && menuItem.current) return 'current';
  if (('subMenu' in menuItem) && deepCurrent(menuItem.subMenu)) return 'deep';
  return false;
}
